import API from 'services/api';

export const fiscalizationF2 = ({ invoiceId }: { invoiceId: string }) =>
  API.post(`/api/documents/invoices/${invoiceId}/fiscalization/f2`)?.then(
    response => response?.data,
  );
